import React from 'react';
import {CLOUDINARY_URL} from "../../constants/GlobalConstants";

export default (props) => {
    return (
        <img style={{width: props.size + "em", height: props.size + "em", borderRadius: "5px"}} src={CLOUDINARY_URL + props.photoUrl} alt={props.name}/>
    );
}